import { UserBase } from '../resources/types';

type EventType = 'apiError' | 'formQuestionSubmitted' | 'Appointment_Requested';

type EventData = {
  event: EventType;
  [field: string]: any;
};

type CurrentUser = UserBase & {
  masterAccountName?: string;
};

export function trackEvent(data: EventData) {
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push(data);
}

export function trackFormQuestionSubmitted(formId: string, formQuestionId: string, formQuestionIndex: number) {
  trackEvent({
    event: 'formQuestionSubmitted',
    formId,
    formQuestionId,
    formQuestionIndex,
  });
}

export function trackUser(user: CurrentUser) {
  if (!(window as any).dataLayer) {
    return;
  }
  const {
    id,
    email,
    createdAt,
    roles,
    master,
    doNotContact,
    organization,
    lastLogin,
    type,
    name,
    masterAccountName,
  } = user;

  (window as any).dataLayer.push({
    event: 'luma-app-loaded',
    createdAt,
    email,
    id,
    isDemoUser: /^demo\+/.test(user.email),
    isMasterAccount: master,
    isDoNotContact: doNotContact,
    isOrganizationAccount: Boolean(organization),
    lastLoginAt: lastLogin,
    masterAccountName: type !== 'patient' ? masterAccountName : '',
    name: type !== 'patient' ? name : '',
    roles,
    user: user.user,
    type,
  });
}
